import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { SummarySession } from "../pages/SummarySession";
import { sessionForResourceContent } from "@sharpana/auth/api_client/summarization_api";
import { Spin } from "antd";
import { css } from "@emotion/css";
import { useSearchParams } from "react-router-dom";

export default function ResourceContentSummary() {
  const [sourceUrl, setSourceUrl] = useState("");
  const [contentToSummarize, setContentToSummarize] = useState(""); // This will come either from the browser extension or from the backend if using webapp without browser extension
  const [contentLength, setContentLength] = useState("");
  const [sessionId, setSessionId] = useState("default");
  const [error, setError] = useState("");

  const params = useParams();
  const resourceContentId = params.resourceContentId;

  // Get 's' (GeneratedResource Slug) url query param
  const [searchParams] = useSearchParams();
  const slugParam = searchParams.get("s");
  const summarizationModeParam = searchParams.get("m");

  const summarizationParamToMode = {
    t: "threadTimeline",
    i: "threadInsights",
  };
  let initialSummarizationMode = "threadInsights";

  if (summarizationModeParam in summarizationParamToMode) {
    initialSummarizationMode = summarizationParamToMode[summarizationModeParam];
  }

  useEffect(() => {
    async function getUrlAndContent() {
      const response = await sessionForResourceContent(resourceContentId);
      console.log(response);

      if (
        response &&
        response.content_length &&
        response.content_to_summarize &&
        response.target_url
      ) {
        setSourceUrl(response.target_url);
        setContentToSummarize(response.content_to_summarize.trim());
        setContentLength(response.content_length);
        setSessionId("default");
      } else {
        // TODO: Give the user the option to retry?
        setError(
          "Please make sure the video already has a transcript and try again (some new videos take a few hours to get their transcript)."
        );
      }
    }

    // The following helps avoid a re-render according to: https://stackoverflow.com/a/57856876
    if (!sourceUrl || !contentToSummarize) {
      setContentToSummarize(""); // TODO: This might need to be controlled via a "loading" state var, instead of using contentToSummarize for that dual purpose (showing loading indicator)
      getUrlAndContent();
    }
  }, []);

  return (
    <div>
      {contentToSummarize && sourceUrl && sessionId ? (
        <SummarySession
          contentToSummarize={String(contentToSummarize)}
          contentLength={contentLength}
          targetUrl={sourceUrl}
          sessionId={sessionId}
          resourceId={resourceContentId} // Pass the actual resource ID for tracking
          // summarizationMode="threadInsights"
          summarizationMode={initialSummarizationMode}
          slugParam={slugParam}
        />
      ) : (
        <div
          className={css`
            text-align: center;
            margin-top: 4rem;
          `}
        >
          {error && error.length > 0 ? (
            <div>{error}</div>
          ) : (
            <Spin size="large" />
          )}
        </div>
      )}
    </div>
  );
}
